<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm11 md10>
          <h3 class="text-center">Pricing Packages</h3>
          <v-card>
            <v-card-title class="py-1">
              <v-text-field label="Search" v-model="filterBy" prepend-icon="search" :disabled="packages.length < 1"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text outlined @click="goTo('/packages/create')" title="Add new Package">
                <v-icon left>mdi-clipboard-plus-outline</v-icon>Add
              </v-btn>
            </v-card-title>
            <v-card-text>
              <view-packages :packages="packages" :search="filterBy"></view-packages>
            </v-card-text>
            <v-card-actions class="py-1">
              <p class="text-muted">* Only active packages will be shown to the user for service requests</p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ViewPackages = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "pricing-packages" */ '@/Components/Packages/packages')

  export default {
    name: 'PackagesIndex',
    layout,
    props: [
      'packages'
    ],
    components: {
      ViewPackages,
    },
    metaInfo () {
      return {
        title: 'Packages',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: ''
      }
    },
  }
</script>
